﻿define(['jquery', 'pubsub', 'generalUtilities'], function locationAutocompleteControl($, pubsub, generalUtilities) {
	'use strict';

	var module;

	module = {};
	module.private = {};

	module.private.handlePlaceChange = function handlePlaceChange(autocomplete, data) {
		var place = autocomplete.getPlace();

		if (generalUtilities.prop(place, 'geometry.location')) {
			data.callbackFunction(place, data.acceptPolygon);
		} else if (generalUtilities.prop(place, 'name') && generalUtilities.prop(place, 'address_components')) { // do not display error if user hit enter instead of this comming from google api
			pubsub.publish('uiAction.MessageAdd', {
				type: 'warning',
				message: RESAAS.Localization.Global.COULD_NOT_FIND_LOCATION
			});
		}
	};

	module.private.handleKeydown = function handleKeydown(event) {
		if (event.keyCode === 13 && $('.pac-container:visible').length) {
			event.preventDefault();
		}
	};

	module.private.handleInput = function handleInput(data) {
		if (data.forceSelect && data.clearFunction) {
			data.clearFunction();
		}
	};

	module.private.handleFocus = function handleFocus(input, data) {
        if (data.forceSelect && input.value) {
			input.value = '';
			if (data.clearFunction) {
				data.clearFunction();
			}
			data.callbackFunction();
		}
	};

	module.private.handleGetCurrentPosition = function handleGetCurrentPosition(autocomplete, position) {
		var circle;

		if (!window.google || !window.google.maps) {
			return;
		}

		circle = new google.maps.Circle({
			center: {
				lat: position.coords.latitude,
				lng: position.coords.longitude
			},
			radius: position.coords.accuracy
		});

		autocomplete.setBounds(circle.getBounds());
	};

	// https://stackoverflow.com/questions/57824711/google-places-overwrite-autocomplete-off
	// the above api window.google.maps.places will set the autocomplete of this element to "off" which is ignored by chrome
	// will need to observe and override this behaviour for chrome
	module.private.observeAutocompleteAttribute = function observeAutocompleteAttribute(elementId) {
		var element, observerHack;
		// if mutation observer doesn't exist just return
		// https://caniuse.com/#feat=mutationobserver 
		// is supported by all browsers but not jest / opera mini
		if (!window.MutationObserver) {
			return;
		}

		element = document.getElementById(elementId);
		if (element) {
			observerHack = new MutationObserver(function observer() {
				observerHack.disconnect();
				element.autocomplete = "off"; // special param to disable autocomplete
			});
			observerHack.observe(element, {
				attributes: true,
				attributeFilter: ['autocomplete']
			});
		}
	};

	module.private.setUpLocationAutoComplete = function setUpLocationAutoComplete(e, data) {
        var useGeoLocate, input, autocomplete;
        var lat, lng;
		useGeoLocate = data.useGeoLocate !== undefined ? data.useGeoLocate : true;
		input = document.getElementById(data.textInputId);

		if (!window.google || !window.google.maps) {
			return;
		}

		autocomplete = new google.maps.places.Autocomplete(input, {
			types: [data.type]
		});

		google.maps.event.addListener(
			autocomplete,
			'place_changed',
			module.private.handlePlaceChange.bind(this, autocomplete, data)
		);

		if (input) {
			input.addEventListener('keydown', module.private.handleKeydown);
			input.addEventListener('input', module.private.handleInput.bind(this, data));
			input.addEventListener('focus', module.private.handleFocus.bind(this, input, data));
		}

        if (useGeoLocate) {
            lat = generalUtilities.prop(window, 'RESAAS.User2.Latitude');
            lng = generalUtilities.prop(window, 'RESAAS.User2.Longitude');

            if (lat && lng) {
                module.private.handleGetCurrentPosition(autocomplete, { coords: { latitude: lat, longitude: lng } });
            } else if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(module.private.handleGetCurrentPosition.bind(this, autocomplete));
            }
        }

		module.private.observeAutocompleteAttribute(data.textInputId);
	};

	module.private.init = function init() {
		pubsub.subscribe('uiWantsToSetupLocationAutocomplete', module.private.setUpLocationAutoComplete);
	};

	module.private.init();

	return module;
});
